import { ClubOnboardingSettingsDTO } from "@gymflow/types";
import { AxiosInstance } from "axios";

const onboardingSettingsApi = (
  axiosInstance: AxiosInstance,
  clubId: number,
) => {
  const clubPrefix = `club/${clubId}/`;

  return {
    getAll() {
      return axiosInstance.get<ClubOnboardingSettingsDTO>(
        `${clubPrefix}onboarding-settings`,
      );
    },
    update(data: ClubOnboardingSettingsDTO) {
      return axiosInstance.patch(`${clubPrefix}onboarding-settings`, data);
    },
  };
};

export default onboardingSettingsApi;
